import PropTypes from "prop-types";
import React, { useRef } from "react";

const SegmentedControl = ({ ariaLabel, onChange, options, value }) => {
  const buttonRefs = useRef([]);

  const moveFocus = (currentIndex, key) => {
    let destination = currentIndex;
    if (["ArrowRight", "ArrowDown"].includes(key))
      destination = (currentIndex + 1) % options.length;
    if (["ArrowLeft", "ArrowUp"].includes(key))
      destination = (currentIndex - 1 + options.length) % options.length;
    if (key === "Home") destination = 0;
    if (key === "End") destination = options.length - 1;
    if (destination === currentIndex) return;
    const destinationButton = buttonRefs.current[destination];
    if (destinationButton) destinationButton.focus();
  };

  return (
    <div className="ccw-segmented" role="group" aria-label={ariaLabel}>
      {options.map((option, index) => (
        <button
          key={option.value}
          ref={(element) => {
            buttonRefs.current[index] = element;
          }}
          type="button"
          className="ccw-segmented__button"
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
          onKeyDown={(event) => {
            if (
              !["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp", "Home", "End"].includes(
                event.key
              )
            )
              return;
            event.preventDefault();
            moveFocus(index, event.key);
          }}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

SegmentedControl.propTypes = {
  ariaLabel: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string.isRequired, value: PropTypes.string.isRequired })
  ).isRequired,
  value: PropTypes.string.isRequired
};

SegmentedControl.defaultProps = {
  ariaLabel: "Choose a view"
};

export default SegmentedControl;
